import { Link } from "react-router-dom";
import { trackingSvg } from "../../assets/imageImport";
import { Fragment } from "react";

export const OrderTrackingContainer = ({ trackingInfo }) => {
  return (
    <Fragment>
      {trackingInfo && trackingInfo.trackOrderNumber && (
        <div className="col-lg-12">
          <div className="summited-orderTracking">
            <h2>Order Tracking</h2>
            <div className="orderTracking-details text-center">
              <h6>
                <img src={trackingSvg} alt="Order Tracking" />
                Your Order has been shipped
              </h6>
              <p>Aust Post: {trackingInfo.trackOrderNumber}</p>
              <div className="button-effect text-center mx-auto">
                <Link to={`/OrderTracking/${trackingInfo.trackOrderNumber}`} className="btn btn-products btn-addcart">
                  Track Order
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
